import { sum, multiply, floatAdd, floatMul } from "@/utils/helpers";
import { getProfit } from "./utils";
import _MixinsCut from "./MixinsCut";

export default class InlandCut extends _MixinsCut {
  constructor(props) {
    super(props);

    this._roomNum = 0;
    this.minRoomNum = 0;
    this.maxRoomNum = this.last_stock;
  }

  get roomNum() {
    return this._roomNum;
  }
  set roomNum(val) {
    this._roomNum = val;
  }

  get totalPriceList() {
    let peoNums = floatMul(this.roomNum, this.min_people);
    let totalPrice = floatMul(this.prices.th.adult_price, peoNums);
    let profit = getProfit(
      this.prices.th.adult_price,
      this.prices.sale.adult_price,
      peoNums
    );
    return [
      {
        title: "成人价格",
        num: peoNums,
        totalPrice,
        profit
      }
    ];
  }
  get totalPrice() {
    // return sum(this.totalPriceList.map(row => row.totalPrice));
    return this.totalPriceList.reduce((sum, row)=> floatAdd(sum, row.totalPrice), 0)
  }
  get totalProfit() {
    // return sum(this.totalPriceList.map(row => row.profit));
    return this.totalPriceList.reduce((sum, row)=> floatAdd(sum, row.profit), 0)
  }
}
